import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants, FormRequiredDocumentsMapping } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-cas-registry-info',
  templateUrl: './cas-registry-info.component.html',
  styleUrls: ['./cas-registry-info.component.scss']
})
export class CasRegistryInfoComponent {
  readonly dialog = inject(MatDialog);
  private documentRequired: boolean = false;

  constructor(protected formService: FormService) {
    this.determineDocumentRequired();
  }

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
          data: { fileName: DocumentConstants.CAS_REGISTRY_INFO }
        });
    dialogRef.afterClosed().subscribe();
  }

  get hasCasRegistryFile(): boolean {
    return this.formService.doesCurrentFormHaveAttachmentForSection(DocumentConstants.CAS_REGISTRY_INFO);
  }

  get attachments(): AttachmentModel[] {
    return this.formService.allAttachmentsForSection(DocumentConstants.CAS_REGISTRY_INFO);
  }

  get isDocumentRequired(): boolean {
    return this.documentRequired;
  }
  
  get showRequiredError(): boolean {
    return this.documentRequired && this.formService.isShowingErrorSections && !this.hasCasRegistryFile;
  }

  private determineDocumentRequired() {
    this.documentRequired = FormRequiredDocumentsMapping.isDocumentRequiredForForm(this.formService.getCurrentUsanFormType(), DocumentConstants.CAS_REGISTRY_INFO);
  }

  get title(): string {
    if(this.isFormBType) {
      return `CAS registry information (Acceptable forms of CAS information below, not required for cell therapies or non-cellular immunotherapies)`;
    }

    return `CAS registry information`;
  }

  get formType(): string {
    return this.formService.getCurrentUsanFormType();
  }
  
  get isFormAType(): boolean {
    return 'FormA' === this.formType;
  }

  get isFormBType(): boolean {
    return 'FormB' === this.formType;
  }

  get isFormCType(): boolean {
    return 'FormC' === this.formType;
  }

  get isFormDType(): boolean {
    return 'FormD' === this.formType;
  }

  get isFormEType(): boolean {
    return 'FormE' === this.formType;
  }

  get isFormFType(): boolean {
    return 'FormF' === this.formType;
  }

}
